'use strict';

// Specified state transitions per particular actions.
export default {
  // Handle a failure to initialize the Ethereum provider.
  updateRedeemedFrens(state, redeemedFrens) {
    state.redeemedFrens = redeemedFrens;
  }
};
